import {AfterViewInit, Component} from '@angular/core';

import {HsDialogContainerService, HsLanguageService} from 'hslayers-ng';

import {AdjusterLoaderComponent} from './adjuster/adjuster-loader/adjuster-loader.component';
import {AppService} from './app.service';

@Component({
  selector: 'app-component',
  templateUrl: './app.component.html',
  styleUrls: ['./custom.scss'],
})
export class AppComponent implements AfterViewInit {
  constructor(
    public appService: AppService,
    //public hsConfig: HsConfig,
    public hsLangService: HsLanguageService,
    public hsDialogContainerService: HsDialogContainerService
  ) {
    //this.hsConfig.update(AppConfig);
  }

  ngAfterViewInit(): void {
    // timeout due to https://angular.io/errors/NG0100
    setTimeout(() => {
      this.hsDialogContainerService.create(AdjusterLoaderComponent, {});
    }, 0);
  }
}
